import {JsonValue, ReportEditorColumn, ReportField, ReportRunOverrides} from '../types/report-builder.types';
import {createReportBody} from './report-builder.helpers';

export const hasReportRunFields = (body: JsonValue): boolean =>
  Boolean(
    body &&
      typeof body === 'object' &&
      !Array.isArray(body) &&
      Object.values(body).some(
        (column) => column && typeof column === 'object' && !Array.isArray(column) && column.isConstant === true,
      ),
  );

export const createReportRunOverrides = (columns: ReportEditorColumn[], fields: ReportField[]): ReportRunOverrides =>
  Object.fromEntries(
    Object.entries(createReportBody(columns, fields)).map(([key, {value, minValue, maxValue}]) => [
      key,
      {
        ...(value !== undefined ? {value} : {}),
        ...(minValue !== undefined ? {minValue} : {}),
        ...(maxValue !== undefined ? {maxValue} : {}),
      },
    ]),
  );
